import { isEmpty, isNumber } from 'lodash';
import moment from 'moment';

export const shouldDisableDate = ({ calendarTimeSlots }) => (momentDate) => {
  if (isEmpty(calendarTimeSlots)) return true;
  const momentDateValue = Number(momentDate.valueOf());
  const date = moment(momentDateValue);

  const currDay = moment();
  const isCurrentDate = date.isSame(currDay, 'day');

  return !calendarTimeSlots.some(timeRange => {

    return isCurrentDate
      ? currDay.isBetween(timeRange.from, timeRange.to)
      || (currDay.isSame(timeRange.from, 'day') && timeRange.from > currDay.valueOf())
      || (currDay.isSame(timeRange.to, 'day') && timeRange.to > currDay.valueOf())
      : date.isBetween(timeRange.from, timeRange.to) || date.isSame(timeRange.from, 'day') || date.isSame(timeRange.to, 'day');
  });
};

export const shouldDisableEndDate = ({ formValues: { date }, calendarTimeSlots }) => momentDate => {
  const endDateValue = Number(momentDate.valueOf());
  const maxDate = moment(date).endOf('day').add(1, 'day').valueOf();

  return (endDateValue !== maxDate && endDateValue > maxDate)
    || moment(date).startOf('day').valueOf() > endDateValue
    || shouldDisableDate({ calendarTimeSlots })(momentDate);
};

export const formatFlexibleInputChange = () => (event, prevValue) => {
  const { value } = event.target;

  if (value && !value.includes(':') && value.length >= 2 && !(prevValue.length >= 3 && value.length <= 2)) {
    event.target.value = `${ event.target.value.slice(0, 2) }:${ event.target.value.slice(2) }`;
  }

  return event;
};

export const onProviderChangeCommon = ({ form, changeFieldValue, clearCalendarTimeSlots }) => () => {
  changeFieldValue(form, 'date', null);
  changeFieldValue(form, 'endDate', null);
  changeFieldValue(form, 'timeSlot', null);
  changeFieldValue(form, 'flexible', null);
  clearCalendarTimeSlots();
};

export const isValidSpecialtyGroupProvider = (id) => isNumber(id);
